import script from "./SubjectInput.vue?vue&type=script&lang=ts&setup=true"
export * from "./SubjectInput.vue?vue&type=script&lang=ts&setup=true"

import "./SubjectInput.vue?vue&type=style&index=0&id=3f84020e&lang=css"
/* custom blocks */
import block0 from "./SubjectInput.vue?vue&type=custom&index=0&blockType=i18n&lang=json"
if (typeof block0 === 'function') block0(script)


const __exports__ = script;

export default __exports__